"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsSanitizedHtml = exports.isSanitizedHtml = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const IsString_1 = require("./IsString");
const validator_1 = __importDefault(require("validator"));
async function isSanitizedHtml(value, args, constraints) {
    const isStringResults = await (0, IsString_1.isString)(value, args, constraints);
    if (isStringResults.pass === false || isStringResults.skipped) {
        return isStringResults;
    }
    // Reverting the HTML escaping first before validating
    const uriDecodedValue = validator_1.default.unescape(value);
    // As the sanitizer add a space in the self closing tags,
    // We will do the first pass without black listing any tags and prettify the tags first
    // Then the 2nd pass will sanitize based on the whitelist value
    const sanitizedTextFirstPass = (0, sanitize_html_1.default)(uriDecodedValue, {
        allowedTags: false,
        allowedAttributes: false,
        allowVulnerableTags: true,
    });
    const sanitizedTextSecondPass = (0, sanitize_html_1.default)(sanitizedTextFirstPass, constraints === null || constraints === void 0 ? void 0 : constraints.sanitizeHtmlOptions);
    const isSanitized = sanitizedTextFirstPass.length === sanitizedTextSecondPass.length;
    if (!isSanitized) {
        return { pass: false, message: "should not contain non-whitelisted HTML tags" };
    }
    return { pass: true };
}
exports.isSanitizedHtml = isSanitizedHtml;
/**
 * Validates that the given HTML is sanitized
 */
function IsSanitizedHtml(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsSanitizedHtml",
        defaultMessage: `should be a sanitized html`,
        options,
        constraints,
        validateFn: isSanitizedHtml,
    });
}
exports.IsSanitizedHtml = IsSanitizedHtml;
//# sourceMappingURL=IsSanitizedHtml.js.map